import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Button from '../Button';
import StackView from '../StackView';

var SubRowToggleCell = function SubRowToggleCell(_ref) {
  var contentsHidden = _ref.contentsHidden,
      rowIndex = _ref.rowIndex,
      toggled = _ref.toggled,
      height = _ref.height,
      restProps = _objectWithoutPropertiesLoose(_ref, ["contentsHidden", "rowIndex", "toggled", "height"]);

  return /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    alignment: "center",
    distribution: "center",
    shrink: 0,
    grow: 0,
    basis: 6,
    width: 6,
    height: height,
    backgroundColor: "inherit",
    zIndex: 35
  }, !contentsHidden && /*#__PURE__*/React.createElement(Button // TODO: expose for better accessibility
  , _extends({
    theme: false,
    title: "Toggle row",
    icon: {
      name: 'arrow-down'
    },
    transform: !toggled && 'rotate(-90deg)'
  }, restProps)));
};

export default SubRowToggleCell;